import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { List, Empty, Space, Button } from "antd";
import { message } from "@bindeleddet/core/utils";
import { StudentNotification } from "@bindeleddet/core/types";
import NotificationBox from "./NotificationBox/NotificationBox";
import MyProfileToolCard from "../MyProfileToolCard/MyProfileToolCard";

const Notifications = () => {
  const history = useHistory();
  const [notifications, setNotifications] = useState<StudentNotification[]>([]);
  const [unread, setUnread] = useState<StudentNotification[]>([]);
  const [fetchingNotifications, setFetchingNotifications] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios
      .get<StudentNotification[]>("/students/student-notifications/")
      .then(response => {
        setNotifications(response.data);
        setUnread(response.data.filter(n => !n.read_at));
      })
      .finally(() => setFetchingNotifications(false));
  }, []);

  const markAllAsRead = async () => {
    try {
      setLoading(true);
      const responses = await Promise.all(
        unread.map(not => axios.post<StudentNotification>(`/students/student-notifications/${not.id}/read/`))
      );
      message("success", "Notifikasjoner markert som lest");
      const updatedNotifications = notifications.map(n => {
        const updated = responses.find(res => res.data.id === n.id);
        return updated ? updated.data : n;
      });
      setNotifications(updatedNotifications);
      setUnread([]);
    } catch {
      message("error", "Notifikasjoner kunne ikke markeres som lest");
    } finally {
      setLoading(false);
    }
  };

  const notificationBoxes = notifications.map(notification => {
    return <NotificationBox key={notification.id} notification={notification} />;
  });

  return (
    <MyProfileToolCard title="Notifikasjoner" onBack={() => history.push("/student-profile")}>
      <Space direction="vertical" style={{ width: "100%" }}>
        {unread.length > 0 ? (
          <Button style={{ marginBottom: "20px" }} type="primary" onClick={markAllAsRead} loading={loading}>
            Merk alle som lest
          </Button>
        ) : null}
      </Space>

      <List
        loading={fetchingNotifications}
        itemLayout="vertical"
        pagination={false}
        locale={{
          emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Du har ingen notfikasjoner" />,
        }}
        style={{ padding: 0, margin: 0 }}
        dataSource={notificationBoxes}
        renderItem={item => item}
      />
    </MyProfileToolCard>
  );
};

export default Notifications;
